export const flattenSettings = (groups = {}) => {
  const flat = {};
  Object.values(groups || {}).forEach((items = []) => {
    items.forEach((item) => {
      if (item?.key) flat[item.key] = item.value ?? '';
    });
  });
  return flat;
};

export const getSettingValue = (flat = {}, keys = [], fallback = '') => {
  for (const key of keys) {
    if (flat?.[key] !== undefined && flat?.[key] !== null && flat?.[key] !== '') {
      return flat[key];
    }
  }
  return fallback;
};

export const getThemeColors = (flat = {}) => ({
  primary: getSettingValue(flat, ['primary_color', 'accent_color'], '#081626'),
  secondary: getSettingValue(flat, ['secondary_color', 'accent_color'], '#00CFFF'),
});

export const getSocialLinks = (flat = {}) => {
  const socials = [];
  const mapping = [
    { key: 'facebook_url', aliases: ['facebook_url', 'social_facebook', 'facebook'], label: 'Facebook', icon: '📘' },
    { key: 'instagram_url', aliases: ['instagram_url', 'social_instagram', 'instagram'], label: 'Instagram', icon: '📸' },
    { key: 'youtube_url', aliases: ['youtube_url', 'social_youtube', 'youtube'], label: 'YouTube', icon: '▶️' },
    { key: 'tiktok_url', aliases: ['tiktok_url', 'social_tiktok', 'tiktok'], label: 'TikTok', icon: '🎵' },
    { key: 'twitter_url', aliases: ['twitter_url', 'social_twitter', 'twitter', 'x_url', 'social_x'], label: 'Twitter', icon: '🐦' },
  ];

  mapping.forEach(({ aliases, label, icon }) => {
    const value = getSettingValue(flat, aliases, '');
    if (value) socials.push({ label, href: value, icon });
  });

  return socials;
};
